import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/api';

/**
 * 出席データをカレンダー表示用に取得するカスタムフック
 * @param patientId 患者ID
 * @param startDate 開始日 (YYYY-MM-DD形式)
 * @param endDate 終了日 (YYYY-MM-DD形式)
 * @returns React Query の結果
 */
export const useAttendanceCalendar = (
  patientId: number | null,
  startDate: string,
  endDate: string
) => {
  return useQuery({
    queryKey: ['attendanceCalendar', patientId, startDate, endDate],
    queryFn: async () => {
      if (!patientId) {
        throw new Error('Patient ID is required');
      }
      return await apiClient.getAttendanceCalendar(patientId, startDate, endDate);
    },
    // 患者IDがnullの場合は実行しない
    enabled: patientId !== null && !!apiClient.getIdToken(),
    // データを5分間キャッシュ
    staleTime: 5 * 60 * 1000,
    // エラー時のリトライ設定
    retry: 1,
    retryOnMount: false,
  });
};

export default useAttendanceCalendar;
